import { transRoutes, RouteType } from '@tencent/iegsp-common/tools/utils/route';
import LAYOUT from '@/layout/index.vue';
import MICRO from '@/components/micro-page/index.vue';

const getRoutes = () => {
  const routes = [
    {
      meta: { title: $t('课堂首页') },
      children: [
        {
          path: '/index',
          component: () => import('@/views/classHomepage/index.vue'),
          meta: { title: $t('课堂首页'), type: RouteType.MENU_ALL },
        },
      ],
    },
    {
      path: '/dashboard',
      redirect: '/dashboard/base',
      meta: {
        title: $t('首页'),
        icon: 'home',
        type: RouteType.MENU_SINGLE,
      },
      children: [
        {
          // 看板页
          path: '/dashboard/base',
          component: () => import('@/views/dashboard/base.vue'),
          meta: { title: $t('首页'), type: RouteType.ALL },
          redirect: '/index',
        },
      ],
    },
    {
      meta: {
        title: $t('课程中心'),
      },
      children: [
        {
          path: '/learning/index/:courseId/:catalogId?',
          name: 'CourseLearning',
          component: () => import('@/views/learning/index.vue'),
          meta: { title: $t('课程学习'), type: RouteType.ALL },
          props: true,
        },
      ],
    },
    {
      meta: { title: $t('审核页面') },
      children: [
        {
          path: '/userReview/index',
          component: () => import('@/views/userReview/index.vue'),
          meta: { title: $t('用户审核'), type: RouteType.ALL },
        },
      ],
    },
    {
      meta: {
        title: $t('调试页面'),
      },
      children: [
        {
          path: '/test',
          component: () => import('@/views/test/test.vue'),
          meta: { title: 'test', type: RouteType.ALL },
        },
      ],
    },
    {
      meta: {
        title: $t('功能页面'),
      },
      children: [
        {
          path: '/login',
          component: () => import('@/views/login/index.vue'),
          meta: {
            title: '登录',
            hideLayout: true,
            hideLayoutFooter: true,
            type: RouteType.ALL,
          },
        },
        {
          path: '/register',
          component: () => import('@/views/register/index.vue'),
          meta: {
            title: '注册',
            hideLayout: true,
            hideLayoutFooter: true,
            type: RouteType.ALL,
          },
        },
        {
          path: '/result/404',
          component: () => import('@/views/result/404.vue'),
          meta: { title: '404', type: RouteType.ALL },
        },
      ],
    },
  ];
  return transRoutes({ routes, LAYOUT, MICRO });
};

export { getRoutes };
